<template>
  <ProSpaceVLayout class="addressprogramorder__rows" style="height: auto;">
    <ProSpaceGeoLayout
      class="geo-row"
      isHideBottom
      isHideTop
      :isHideRight="!isError"
    >
      <template v-slot:left>
        <ProSpaceTextBlock
          :top="title"
          :bottom="description"
          :gap="10"
          break-word
        />
      </template>
      <template v-slot:center>
        <ProSpaceVLayout :gap="20">
          <ProSpaceHLayout
            v-for="row in Math.ceil(fields.length / 3)"
            :key="row"
            justify-content="flex-start"
            align-items="flex-start"
            :gap="15"
          >
            <div
              style="width: 100%;"
              v-for="(input, index) in 3"
              :key="fields[getFieldIndex(row, index)]"
            >
              <ProSpaceInputNumber
                v-if="fields[getFieldIndex(row, index)]"
                v-bind="getInputProps(row, index)"
                :ref="`${fields[getFieldIndex(row, index)]}-ProSpaceInputNumber`"
                v-model="model[fields[getFieldIndex(row, index)]]"
                :invalid="v$.model[fields[getFieldIndex(row, index)]]?.$error"
                :invalid-messages="v$.model[fields[getFieldIndex(row, index)]]?.$errors"
                @blur="v$.model[fields[getFieldIndex(row, index)]]?.$touch"
                @input="onInputNumber(fields[getFieldIndex(row, index)])"
              />
            </div>
          </ProSpaceHLayout>
        </ProSpaceVLayout>
      </template>

      <template
        v-if="isError"
        v-slot:right
      >
        <ProSpaceVLayout justify-content="center">
          <ProSpaceIcon icon="warning" colored />
        </ProSpaceVLayout>
      </template>
    </ProSpaceGeoLayout>
  </ProSpaceVLayout>
  <ProSpaceVLayout v-show="adjustmentMode && enabledComments" class="addressprogramorder__rows" style="height: auto;">
    <ProSpaceGeoLayout
      class="geo-row"
      isHideBottom
      isHideTop
      :isHideRight="!v$.model.comment.$error"
    >
      <template v-slot:left>
        <ProSpaceTextBlock
          :top="$t('addressProgramCommentInfo')"
          :bottom="$t('addressProgramCommentDescription')"
          :gap="10"
          break-word
        />
      </template>
      <template v-slot:center>
        <ProSpaceVLayout :gap="20">
          <ProSpaceHLayout
            justify-content="flex-start"
            align-items="flex-start"
            :gap="15"
          >
            <ProSpaceInputText
              v-model="model.comment"
              ref="comments-ProSpaceInputText-alt"
              class="addressprogramorder__input-textarea"
              style="width: 100%; max-width: 100%;"
              :rows="3"
              :label="$t('addressProgramCommentInfo')"
              :placeholder="$t('addressProgramCommentInfo')"
              isTextarea
              :invalid="v$.model.comment.$error"
              :invalid-messages="v$.model.comment.$errors"
              @blur="v$.model.comment.$touch"
              @update:modelValue="onUpdateTextarea"
            />
          </ProSpaceHLayout>
        </ProSpaceVLayout>
      </template>
      <template v-if="v$.model.comment.$error" v-slot:right>
        <ProSpaceVLayout justify-content="center">
          <ProSpaceIcon icon="warning" colored />
        </ProSpaceVLayout>
      </template>
    </ProSpaceGeoLayout>
  </ProSpaceVLayout>
</template>
<script>
import {
  ProSpaceGeoLayout,
  ProSpaceTextBlock,
  ProSpaceVLayout,
  ProSpaceHLayout,
  ProSpaceInputNumber,
  ProSpaceInputText,
  ProSpaceIcon
} from "@prospace/prospace-components-library";
import accessMixin from "../../../../../../Frontends/Common/utils/elementAccess/accessMixin";

export default {
  name: "AddressProgramOrderTabKPI",
  components: {
    ProSpaceIcon,
    ProSpaceInputNumber,
    ProSpaceInputText,
    ProSpaceHLayout,
    ProSpaceVLayout,
    ProSpaceTextBlock,
    ProSpaceGeoLayout
  },
  emits: ['update:model', 'access:loaded'],
  mixins: [accessMixin],
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    fields: {
      type: Array,
      required: true
    },
    importModel: {
      type: Object,
      required: true,
    },
    adjustmentFields: {
      type: Array,
      required: true
    },
    v$: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    postFixLabel: {
      type: String,
    },
    adjustmentMode: {
      type: Boolean,
    },
    access: {
      type: Object
    },
    userInfo: {
      type: Object
    },
    orderStatus: {
      type: Boolean
    },
    needCheckOrderStatusForMountAccess: {
      type: Boolean
    },
    enabledComments: {
      type: Boolean
    },
    isMultiAdjustmentMode: {
      type: Boolean
    }
  },
  data() {
    return {
      model: {
        comment: ''
      },
    }
  },
  watch: {
    importModel: {
      handler: function (val) {
        for (let key of this.fields) {
          // console.log(val, key, val[key])
          if (val[key] || val[key] === 0) {
            if (!this.model?.hasOwnProperty(key)) {
              this.model = {...this.model, [key]: val[key]};
            } else {
              this.model[key] = val[key];
            }
          } else {
            this.model[key] = null;
          }
        }
        if ('comment' in val && this.enabledComments) {
          this.model.comment = val.comment;
        }
      },
      immediate: true,
      deep: true
    },
    mixinLoadingAccess: {
      handler: function (val) {
        this.$emit("access:loaded", val);
      }
    },
  },
  computed: {
    isError() {
      return Object.keys(this.v$.model).some(field => this.fields[field]?.$error);
    },
    refsForCheckInMixin() {
      let refs = [];
      refs.push(
        ...this.fields.map(field => `${field}-ProSpaceInputNumber`)
      );

      return refs;
    },
  },
  methods: {
    getLabelString(field) {
      return `${this.$t(`addressProgramOrder${field.substring(0, 1).toUpperCase() + field.slice(1)}`).trim()}${this.postFixLabel ? ', ' + this.postFixLabel : ''}`;
    },
    getInputProps(row, index) {
      const i = this.getFieldIndex(row, index);
      const field = this.fields[i];
      return {
        integeronly: false,
        minFractionDigits: 2,
        maxFractionDigits: 2,
        min: 0,
        label: `${this.getLabelString(field)}`,
        placeholder: this.adjustmentFields.includes(field) && this.isMultiAdjustmentMode
          ? this.$t('addressProgramOrderAdjustmentNewValue')
          : this.getLabelString(field).trim(),
        invalid: this.v$.model[field]?.$error,
        invalidMessage: this.v$.model[field]?.$errors,
        likeText: true,
        disabled: this.disabled
      }
    },
    getFieldIndex(row, index) {
      return index + ((row - 1) * 3);
    },
    onInputNumber(field) {
      this.$emit("update:model", {[field]: this.model[field]});
    },
    onUpdateTextarea() {
      this.$emit("update:model", {['comment']: this.model.comment});
    },
    refreshMountAccess() {
      this.clearAllCondition()
      this.mountAccess('addressprogramorder', true, this.needCheckOrderStatusForMountAccess);
    },
  },
  mounted() {
    this.loadRoleAccess('addressprogramorder');
    this.mountAccess('addressprogramorder', true, this.needCheckOrderStatusForMountAccess);
  }
}
</script>
<style lang="scss">
.addressprogramorder__rows {
  .prospace-input-number {
    .p-inputtext {
      &:disabled {
        &::placeholder {
          color: var(--prospace-ui-icon-gray);
        }
      }
    }
  }
}
</style>
<script setup lang="ts">
</script>
